// autocomplete

export default class OffersAutocomplete  {

    constructor() {


        if ( jQuery('#jobQ__title').length > 0 && typeof DATA.lists_autocomplete != "undefined") {

            jQuery('#jobQ__title').autocomplete({

                source: function(request, response) {
                    var results = jQuery.ui.autocomplete.filter(DATA.lists_autocomplete, request.term);

                    response(results.slice(0, 10));

                },
                open: function(){ jQuery('.ui-autocomplete').css( 'width',  jQuery('#jobQ__title').width() );  }

            }).data( "ui-autocomplete" )._renderItem = function( ul, item ) {
                return jQuery( "<li>" )
                    .attr( "data-value", item.value )
                    .append( jQuery( "<button>" ).text( item.label ) )
                    .appendTo( ul );
            };

        }
    }


}





